import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import styles from "./nav-menu-item.scss";

/**
 * Navigation Menu item.
 * Use only insed the NavigationMenu component.
 */
export default function NavigationMenuItem(props) {
    const { icon, label, to } = props;
    return (
        <div className={styles.wrapper}>
            <NavLink to={to} className={({isActive}) => isActive ? styles.active : undefined} end>
                <div className={styles.content}>
                    {icon !== undefined && <div className={styles.icon}>{icon}</div>}
                    <div className={styles.label}>
                        <span>{label}</span>
                    </div>
                </div>
            </NavLink>
        </div>
    )
};

NavigationMenuItem.propTypes = {
    /**
     * Menu Item label.
     */
    label: PropTypes.string,
    /**
     * Icon component.
     */
    icon: PropTypes.element,
    /**
     * Is menu item active.
     */
    active: PropTypes.bool,
    /**
     * Menu item navigation destination.
     */
    to: PropTypes.string.isRequired
};